import { Component, OnInit, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as cloneDeep from 'lodash/cloneDeep';
@Component({
  selector: 'app-activities-of-daily-living',
  templateUrl: './activities-of-daily-living.component.html',
  styleUrls: ['./activities-of-daily-living.component.scss'],
})
export class ActivitiesOfDailyLivingComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  isLoading: boolean = false;
  checkDiability: boolean = false;
  disabilityLevelList = [];
  dailyLivingDetails = [];

  constructor(
    private commonService: CommonService,
    private dialogRef: MatDialogRef<ActivitiesOfDailyLivingComponent>,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  async ngOnInit() {
    await this.initialDropdown();
    if( this.data.dailyLivingDetails == null || this.data.dailyLivingDetails == undefined || this.data.dailyLivingDetails == ''){
      this.dailyLivingDetails = this.commonService.dailyLivingDetails;
      console.log('dailyLivingDetailsDropDownFromCommon', this.commonService.dailyLivingDetails)
    }else {
      this.dailyLivingDetails = this.data.dailyLivingDetails;
      console.log('dailyLivingDetailsUpdated', this.dailyLivingDetails);
    }     console.log('dailyActivities', this.dailyLivingDetails);
  }
  onChange(event) {}

  onDataInput(event, key, indexItem) {
    console.log('this is item ', indexItem);
    if (key == 'isSelected') {
      this.dailyLivingDetails[indexItem][key] =
        !this.dailyLivingDetails[indexItem][key];
      if (indexItem == this.dailyLivingDetails.length - 1) {
        for (let item of this.dailyLivingDetails) {
          item[key] = false;
          item['activityDate'] = null;
        }
      }
    } else {
      this.dailyLivingDetails[indexItem][key] = event;
    }
  }

  getErrorMessage(key) {
    return '';
  }

  async initialDropdown() {
    this.isLoading = true;
    try {
      let url =
        environment.API_CONFIG_URL +
        'configuration/lookup?list=DisabilityLevel';
      let dropDownResponse = await this.commonService.commonGet(url);
      this.disabilityLevelList = dropDownResponse.body.DisabilityLevel;
      this.commonService.dailyLivingDetails = [];
      for (let item of this.disabilityLevelList) {
        let tempItem = { isSelected: false, activity: item.label, activityKey: '', activityDate: null };       
                 // Set activityKey based on the conditions from API side//
    switch (item.value) {
      case 'A':
        tempItem.activityKey = 'F';
        break;
      case 'B':
        tempItem.activityKey = 'B';
        break;
      case 'C':
        tempItem.activityKey = 'M';
        break;
      case 'D':
        tempItem.activityKey = 'T';
        break;
      case 'E':
        tempItem.activityKey = 'W';
        break;
      case 'F':
        tempItem.activityKey = 'D';
        break;
      case 'G':
        tempItem.activityKey = 'N';
        break;
      default:
        break;
    }
         this.commonService.dailyLivingDetails.push(cloneDeep(tempItem));

      }
      this.dailyLivingDetails = cloneDeep(
        this.commonService.dailyLivingDetails
      );
      this.isLoading = false;
    } catch (err) {
      console.log('Get API Error - DisabilityLevel Data', err);
      this.isLoading = false;
    }
  }

  async onCloseDialog() {
    this.dialogRef.close();
  }
}
